import { request } from '@subaio/utils'

type CsrfToken = {
	parameterName: string
	token: string
}

export const submitOAuthForm = async (action: string, values: Record<string, string>) => {
	// The browser does not inherit the cookies from the MCP client that started authorization.
	const csrf = await request<CsrfToken>({ url: '/mcp-oauth/oauth2/csrf', credentials: 'same-origin' })
	const form = document.createElement('form')
	form.action = action
	form.method = 'post'
	Object.entries({ ...values, [csrf.parameterName]: csrf.token }).forEach(([name, value]) => {
		const input = document.createElement('input')
		input.name = name
		input.type = 'hidden'
		input.value = value
		form.appendChild(input)
	})

	document.body.appendChild(form)
	form.submit()
}
